var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3199 27.3199C30.2157 24.4241 32 20.4168 32 16C32 11.5832 30.2157 7.57587 27.3199 4.68007C24.4241 1.78428 20.4168 0 16 0C11.5832 0 7.57587 1.78428 4.68007 4.68007C1.78428 7.57587 0 11.5832 0 16C0 20.4168 1.78428 24.4241 4.68007 27.3199C7.57587 30.2157 11.5832 32 16 32C20.4168 32 24.4241 30.2157 27.3199 27.3199ZM18.1645 22.1718C18.1645 20.9726 17.1993 20.0073 16 20.0073C14.8007 20.0073 13.8062 20.9726 13.8062 22.1718C13.8062 23.3711 14.8007 24.3656 16 24.3656C17.1993 24.3656 18.1645 23.3711 18.1645 22.1718ZM16 17.8135C15.2102 17.8135 14.6252 17.17 14.5375 16.351L13.8062 9.82815C13.6892 8.68739 14.8885 7.63437 16 7.63437C17.1115 7.63437 18.3108 8.68739 18.1645 9.82815L17.4625 16.351C17.3748 17.17 16.7898 17.8135 16 17.8135Z",
    fill: "#FF3D00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.8fd0bf06cb6009d21d5f9d73e7bb57d9.svg";
export { ForwardRef as ReactComponent };